/**
 * useGuestSubtaskOperations — Subtask operations for guest goals.
 */
import { Goal } from "@/types/todo";
import { Dispatch, SetStateAction } from "react";

export const useGuestSubtaskOperations = (
  goals: Goal[],
  setGoals: Dispatch<SetStateAction<Goal[]>>
) => {
  const addSubtask = ({ goalTitle, todoId, subtaskText }: { goalTitle: string, todoId: string, subtaskText: string }) => {
    setGoals(prevGoals =>
      prevGoals.map(goal =>
        goal.title === goalTitle
          ? {
              ...goal,
              todos: goal.todos.map(todo =>
                todo.id === todoId
                  ? { ...todo, subtasks: [...todo.subtasks, { id: crypto.randomUUID(), text: subtaskText, completed: false }] }
                  : todo
              ),
            }
          : goal
      )
    );
  };

  const deleteSubtask = ({ goalTitle, todoId, subtaskId }: { goalTitle: string, todoId: string, subtaskId: string }) => {
    setGoals(prevGoals =>
      prevGoals.map(goal =>
        goal.title === goalTitle
          ? {
              ...goal,
              todos: goal.todos.map(todo =>
                todo.id === todoId
                  ? { ...todo, subtasks: todo.subtasks.filter(subtask => subtask.id !== subtaskId) }
                  : todo
              ),
            }
          : goal
      )
    );
  };

  const toggleSubtask = ({ goalTitle, todoId, subtaskId }: { goalTitle: string, todoId: string, subtaskId: string }) => {
    setGoals(prevGoals =>
      prevGoals.map(goal =>
        goal.title === goalTitle
          ? {
              ...goal,
              todos: goal.todos.map(todo =>
                todo.id === todoId
                  ? {
                      ...todo,
                      subtasks: todo.subtasks.map(subtask =>
                        subtask.id === subtaskId ? { ...subtask, completed: !subtask.completed } : subtask
                      ),
                    }
                  : todo
              ),
            }
          : goal
      )
    );
  };

  const updateSubtaskDueDate = ({ goalTitle, todoId, subtaskId, dueDate }: 
    { goalTitle: string; todoId: string; subtaskId: string; dueDate: string | null }) => {
    
    setGoals(prevGoals => {
      return prevGoals.map(goal => {
        if (goal.title !== goalTitle) return goal;
        
        return {
          ...goal,
          todos: goal.todos.map(todo => {
            if (todo.id !== todoId) return todo;
            
            return {
              ...todo,
              subtasks: todo.subtasks.map(subtask => {
                if (subtask.id !== subtaskId) return subtask;
                return {
                  ...subtask,
                  due_date: dueDate
                };
              })
            };
          })
        };
      });
    });
  };

  const updateSubtaskText = ({ goalTitle, todoId, subtaskId, newText }: 
    { goalTitle: string; todoId: string; subtaskId: string; newText: string }) => {
    
    setGoals(prevGoals => {
      return prevGoals.map(goal => {
        if (goal.title !== goalTitle) return goal;
        
        return {
          ...goal,
          todos: goal.todos.map(todo => {
            if (todo.id !== todoId) return todo;
            
            return {
              ...todo,
              subtasks: todo.subtasks.map(subtask => {
                if (subtask.id !== subtaskId) return subtask;
                return {
                  ...subtask,
                  text: newText
                };
              })
            };
          })
        };
      });
    });
  };

  return {
    addSubtask,
    deleteSubtask,
    toggleSubtask,
    updateSubtaskDueDate,
    updateSubtaskText
  };
};
